<template>
  <div class="poiTypeContainer">
    <Toggle ref="toggle" @update:value="toggleUpdate"></Toggle>
    <ToggleLabel :iconSrc="iconSrc" :name="name" />
  </div>
</template>

<script>
import Toggle from '@wizer/core/components/toggle/Toggle'
import ToggleLabel from './ToggleLabel'

export default {
  /**
   * Name of the component
   */
  name: 'PoiTypeOption',

  /**
   * Components
   */
  components: {
    Toggle,
    ToggleLabel,
  },

  /**
   * This components properties
   */
  props: {
    name: String,
    id: String,
    iconSrc: String,
  },
  /**
   * Component methods
   */
  methods: {
    /**
     * Receives toggle updates and emit a toggle event
     * @param value current toggle value
     */
    toggleUpdate(value) {
      this.$emit('toggleUpdate', { id: this.id, value, type: 'poiTypeOptionUpdated' })
    },
  },
}
</script>
<style lang="postcss" scoped>
.poiTypeContainer {
  @apply flex;
}
</style>
